// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"1e76a94d","169":"a736f401","449":"06ba4949","469":"06b7ff40","543":"443fdf6e"}[chunkId] + ".chunk.js";
};